var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon09(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.0937 64.875L65.8438 62.625C67 60.875 67.6875 58.75 67.6875 56.5C67.6875 50.3125 62.6875 45.3125 56.5 45.3125C50.3125 45.3125 45.3125 50.3125 45.3125 56.5C45.3125 62.6875 50.3125 67.6875 56.5 67.6875C58.7813 67.6875 60.875 67 62.625 65.8438L64.875 68.0938C65.3125 68.5313 65.9063 68.75 66.4688 68.75C67.0625 68.75 67.625 68.5313 68.0625 68.0938C68.9687 67.1875 68.9687 65.75 68.0937 64.875Z",
    fill: "#58247E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.34376 45.7188C6.34376 45.8125 6.28125 45.9375 6.28125 46.0313C9.15625 51.7813 13.8438 56.5 19.5938 59.3437C19.6875 59.3437 19.8125 59.2812 19.9063 59.2812C18.8438 55.6562 18.0313 51.9375 17.4375 48.2187C13.6875 47.5937 9.96876 46.7812 6.34376 45.7188Z",
    fill: "#58247E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M59.5938 20.0937C56.6563 13.9375 51.6875 8.96875 45.5625 6.0625C46.6875 9.78125 47.625 13.5938 48.25 17.4063C52.0625 18.0313 55.875 18.9375 59.5938 20.0937Z",
    fill: "#58247E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.03125 20.0938C9.78125 18.9688 13.5938 18.0313 17.4063 17.4063C18.0313 13.6876 18.8125 10.0001 19.875 6.37506C19.7813 6.37506 19.6563 6.3125 19.5625 6.3125C13.6875 9.21875 8.90625 14.125 6.03125 20.0938Z",
    fill: "#58247E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M43.1875 16.75C42.4375 12.6875 41.5 8.62503 40.1563 4.68753C40.0938 4.46878 40.0938 4.28131 40.0625 4.03131C37.75 3.46881 35.3125 3.09375 32.8125 3.09375C30.2813 3.09375 27.875 3.43756 25.5313 4.03131C25.5 4.25006 25.5313 4.43753 25.4688 4.68753C24.1563 8.62503 23.1875 12.6875 22.4375 16.75C29.3438 16 36.2813 16 43.1875 16.75Z",
    fill: "#58247E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.75 22.4375C12.6562 23.1875 8.62498 24.125 4.68748 25.4688C4.46873 25.5313 4.28121 25.5312 4.03121 25.5625C3.46871 27.875 3.09375 30.3125 3.09375 32.8125C3.09375 35.3438 3.43746 37.75 4.03121 40.0937C4.24996 40.125 4.43748 40.0938 4.68748 40.1563C8.62498 41.4688 12.6562 42.4375 16.75 43.1875C16 36.2813 16 29.3438 16.75 22.4375Z",
    fill: "#58247E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M61.5625 25.5625C61.3437 25.5625 61.1563 25.5313 60.9063 25.4688C56.9688 24.1563 52.9062 23.1875 48.8438 22.4375C49.625 29.3438 49.625 36.2813 48.8438 43.1563C52.9062 42.4063 56.9688 41.4688 60.9063 40.125C61.125 40.0625 61.3125 40.0938 61.5625 40.0625C62.125 37.7188 62.5 35.3125 62.5 32.7812C62.5 30.3125 62.1562 27.9062 61.5625 25.5625Z",
    fill: "#58247E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.4375 48.875C23.1875 52.9688 24.125 57 25.4688 60.9375C25.5313 61.1562 25.5 61.3437 25.5313 61.5937C27.875 62.1562 30.2813 62.5312 32.8125 62.5312C35.3125 62.5312 37.75 62.1874 40.0625 61.5937C40.0938 61.3749 40.0938 61.1875 40.1563 60.9375C41.4688 57 42.4375 52.9688 43.1875 48.875C39.75 49.25 36.2813 49.5312 32.8125 49.5312C29.3438 49.5 25.875 49.25 22.4375 48.875Z",
    fill: "#58247E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.7188 21.7188C20.7812 29.0938 20.7812 36.5312 21.7188 43.9375C29.0938 44.875 36.5313 44.875 43.9375 43.9375C44.875 36.5625 44.875 29.125 43.9375 21.7188C36.5313 20.7812 29.0938 20.7812 21.7188 21.7188Z",
    fill: "#58247E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon09);
export default __webpack_public_path__ + "static/media/icon-09.704e8ad22a8e9b756fe5d796a7a24efe.svg";
export { ForwardRef as ReactComponent };